export const initProductQtySelectors = (root = document) => {
  const optionGroups = root.querySelectorAll("[data-qty-options]");

  optionGroups.forEach((group) => {
    if (group.dataset.qtyBound === "true") return;
    const container = group.closest("form") || group.parentElement;
    const input = container?.querySelector("[data-qty-input]");
    const display = container?.querySelector("[data-qty-display]");
    const displayTrigger = container?.querySelector(
      "[data-qty-display-trigger]",
    );
    const displayArrow = container?.querySelector("[data-qty-arrow]");
    const priceBox = container?.querySelector(
      "[data-price-calculation-display]",
    );
    const priceTotal = container?.querySelector("[data-price-total]");
    const buttons = Array.from(group.querySelectorAll("[data-qty-value]"));
    const customInput = group.querySelector("[data-qty-custom]");
    if (!input || !display || !displayTrigger) return;

    const updatePriceTotal = (value) => {
      if (!priceBox || !priceTotal) return;
      const unit = parseFloat(priceBox.dataset.priceValue || "0");
      const qty = parseFloat(String(value)) || 0;
      const total = unit * qty;
      priceTotal.textContent = total.toFixed(2);
    };

    const setActive = (value) => {
      input.value = String(value);
      display.textContent = String(value);
      updatePriceTotal(value);
      buttons.forEach((btn) => {
        btn.classList.toggle(btn.dataset.qtyValue === value);
      });
    };

    setActive(input.value || "1");
    group.dataset.qtyBound = "true";

    const closeAllOptionGroups = () => {
      const allGroups = container?.querySelectorAll(
        "[data-qty-options], [data-abo-options], [data-pickup-options]",
      );
      allGroups?.forEach((g) => {
        g.classList.remove("flex", "flex-col", "h-auto");
        g.classList.add("h-0");
      });
      container
        ?.querySelectorAll(
          "[data-qty-arrow], [data-abo-arrow], [data-pickup-arrow]",
        )
        .forEach((arrow) => arrow.classList.remove("hidden"));
      container
        ?.querySelectorAll(
          "[data-qty-display-trigger], [data-abo-display-trigger], [data-pickup-display-trigger]",
        )
        .forEach((trigger) => trigger.classList.remove("hover:border-b"));
    };

    displayTrigger.addEventListener("click", () => {
      const isClosed = group.classList.contains("h-0");
      closeAllOptionGroups();
      if (isClosed) {
        group.classList.remove("h-0");
        group.classList.add("flex", "flex-col", "h-auto");
        displayArrow?.classList.add("hidden");
        displayTrigger.classList.add("hover:border-b");
      }
    });

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const value = btn.dataset.qtyValue || "1";
        setActive(value);
        //closeAllOptionGroups();
      });
    });

    if (customInput) {
      const updateCustom = () => {
        const raw = parseInt(customInput.value, 10);
        if (!Number.isFinite(raw) || raw <= 0) return;
        setActive(String(raw));
        //closeAllOptionGroups();
      };
      customInput.addEventListener("input", updateCustom);
      customInput.addEventListener("change", updateCustom);
    }
  });
};

// Abo disabled for now
export const initProductAboSelectors = () => {};

export const initProductPickupSelectors = (root = document) => {
  const optionGroups = root.querySelectorAll("[data-pickup-options]");

  optionGroups.forEach((group) => {
    if (group.dataset.pickupBound === "true") return;
    const container = group.closest("form") || group.parentElement;
    const input = container?.querySelector("[data-pickup-input]");
    const display = container?.querySelector("[data-pickup-display]");
    const displayTrigger = container?.querySelector(
      "[data-pickup-display-trigger]",
    );
    const displayArrow = container?.querySelector("[data-pickup-arrow]");
    const buttons = Array.from(group.querySelectorAll("[data-pickup-value]"));
    if (!input || !display || !displayTrigger || buttons.length === 0) return;

    const setActive = (value, label) => {
      input.value = String(value);
      display.textContent = label || String(value);
      buttons.forEach((btn) => {
        btn.classList.toggle(btn.dataset.pickupValue === value);
      });
    };

    // Get initial label from first button or display
    const firstBtn = buttons[0];
    const initialValue = input.value || firstBtn?.dataset.pickupValue || "";
    const initialLabel =
      display.textContent || firstBtn?.dataset.pickupLabel || initialValue;
    setActive(initialValue, initialLabel);
    group.dataset.pickupBound = "true";

    const closeAllOptionGroups = () => {
      const allGroups = container?.querySelectorAll(
        "[data-qty-options], [data-abo-options], [data-pickup-options]",
      );
      allGroups?.forEach((g) => {
        g.classList.remove("flex", "flex-col", "h-auto");
        g.classList.add("h-0");
      });
      container
        ?.querySelectorAll(
          "[data-qty-arrow], [data-abo-arrow], [data-pickup-arrow]",
        )
        .forEach((arrow) => arrow.classList.remove("hidden"));
      container
        ?.querySelectorAll(
          "[data-qty-display-trigger], [data-abo-display-trigger], [data-pickup-display-trigger]",
        )
        .forEach((trigger) => trigger.classList.remove("hover:border-b"));
    };

    displayTrigger.addEventListener("click", () => {
      const isClosed = group.classList.contains("h-0");
      closeAllOptionGroups();
      if (isClosed) {
        group.classList.remove("h-0");
        group.classList.add("flex", "flex-col", "h-auto");
        displayArrow?.classList.add("hidden");
        displayTrigger.classList.add("hover:border-b");
      }
    });

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const value = btn.dataset.pickupValue || "";
        const label = btn.dataset.pickupLabel || value;
        setActive(value, label);
        // closeAllOptionGroups();
      });
    });
  });
};

initProductQtySelectors();
// initProductAboSelectors(); // Abo disabled for now
initProductPickupSelectors();
